import React, { useState } from 'react';
import styles from './Notes.module.css';

import ClickableButton from '../../../components/ClickableButton/ClickableButton';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { FaRegClock } from 'react-icons/fa';
import { FiEdit, FiTrash } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';

const Notes = () => {
  const [filterBy, setFilterBy] = useState('Created By');
  const dispatch = useDispatch();

  const notesData = [
    {
      id: 1,
      name: 'John Jacob',
      date: '05/06/2025',
      time: '8:00 AM–11:00 AM',
      noteTitle: 'Note',
      noteText: 'Note 1',
    },
  ];

  return (
    <div className={styles.NotesWrapper}>
      <div className={styles.dropdownWrapper}>
        <Dropdown
          label="Created By"
          options={['Created By', 'Edited By']}
          onChange={(val) => setFilterBy(val)}
          showAllOption={false}
        />
      </div>

      <div className={styles.notesList}>
        {notesData.map((note) => (
          <div key={note.id} className={styles.noteCard}>
            <div className={styles.noteHeader}>
              <div className={styles.userInitials}>J</div>
              <div className={styles.userDetails}>
                <h4 className={styles.name}>{note.name}</h4>
                <div className={styles.meta}>
                  <span>{note.date}</span>
                  <FaRegClock className={styles.clockIcon} />
                  <span>{note.time}</span>
                </div>
              </div>

              <div className={styles.actions}>
                <FiEdit
                  className={styles.iconEdit}
                  onClick={() => dispatch(openModal('editNote'))}
                />
                <FiTrash
                  className={styles.iconDelete}
                  onClick={() => dispatch(openModal('delete'))}
                />
              </div>
            </div>

            <div className={styles.noteContent}>
              <h5 className={styles.noteTitle}>{note.noteTitle}</h5>
              <p className={styles.noteText}>{note.noteText}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notes;
